<template>
  <div>
    <div class="swiperBox">
      <swiper
        ref="mySwiper"
        :options="swiperOption"
        :style="{ height: swiperContainerHeight + 'px' }"
      >
        <swiper-slide
          v-for="(itme, index) in selectList"
          :key="index"
          :class="{ selectFirst: isSelectFirst, selectLast: isSelectLast }"
          >{{ itme.text }}</swiper-slide
        >

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import CommonApiMixin from '@/mixins/commonApi';

import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'SelectSwiper',

  mixins: [CommonApiMixin],

  components: { Swiper, SwiperSlide },

  props: {
    filterType: {
      type: String,
      default: '',
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    monthActiveIdx: {
      type: Number,
      default: 0,
    },
    statusActiveIdx: {
      type: Number,
      default: 0,
    },
    swiperContainerHeight: {
      type: String,
      default: '40',
    },
  },

  data() {
    const vue = this;
    return {
      isSelectFirst: false,
      isSelectLast: false,
      activeIdx: 0,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        vertical: true,
        verticalSwiping: true,
      },
      swiperOption: {
        direction: 'vertical',
        paginationClickable: true,
        mousewheelControl: true,
        on: {
          init(swiper) {
            if (vue.filterType === 'M') {
              swiper.slideTo(vue.monthActiveIdx, 1, false);
              this.activeIdx = vue.monthActiveIdx;
            } else if (vue.filterType === 'S') {
              swiper.slideTo(vue.statusActiveIdx, 1, false);
              this.activeIdx = vue.statusActiveIdx;
            }
          },
          slideChangeTransitionStart() {
            vue.activeIdx = this.realIndex;
            vue.$emit('activeIdxEmit', vue.activeIdx);
          },
        },
      },
    };
  },
};
</script>
